export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const USER_ENDPOINT = `${API_BASE_URL}`;
export const PRICE_SCHEDULE_MODES = {
  ADD: "Add",
  EDIT: "Change",
  READ_ONLY: "View",
};

export const ROUTE_PATHS = {
  PRICE_SCHEDULE: "/price-schedule",
  ADD_PRICE_SCHEDULE: "/add-price-schedule",
  EDIT_PRICE_SCHEDULE: "/edit-price-schedule",
  DISPLAY_PRICE_SCHEDULE: "/display-price-schedule",
  COPY_PRICE_SCHEDULE: "/copy-price-schedule",
  PRICE_SCHEDULE_NOTE: "/price-schedule-note",
  DEDUCTIBLE_SCHEDULE_STEPS: "/deductible-schedule-steps",
  ADD_OUT_OF_POCKET_MAX_SCHEDULE: "/add-out-of-pocket-schedule",
  EDIT_OUT_OF_POCKET_MAX_SCHEDULE: "/edit-out-of-pocket-schedule",
  DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE: "/display-out-of-pocket-schedule",
  OUT_OF_POCKET_MAX_SCHEDULE: "/out-of-pocket-schedule",
  OUT_OF_POCKET_MAX_SCHEDULE_STEPS: "/out-of-pocket-schedule-steps",
  OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT:
    "/out-of-pocket-schedule-steps-details-ext",
  ADD_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL: "/add-out-of-pocket-max-detail",
  EDIT_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL: "/edit-out-of-pocket-max-detail",
  DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL:
    "/display-out-of-pocket-max-detail",
  ADD_OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT:
    "/add-out-of-pocket-schedule-steps-details-ext",
  EDIT_OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT:
    "/edit-out-of-pocket-schedule-steps-details-ext",
  DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT:
    "/display-out-of-pocket-schedule-steps-details-ext",
  DEDUCTIBLE_SCHEDULE: "/deductible-schedule",
  ADD_DEDUCTIBLE_SCHEDULE: "/add-deductible-schedule",
  EDIT_DEDUCTIBLE_SCHEDULE: "/edit-deductible-schedule",
  DISPLAY_DEDUCTIBLE_SCHEDULE: "/display-deductible-schedule",
  DEDUCTIBLE_SCHEDULE_NOTE: "/deductible-schedule-note",
  ADD_DEDUCTIBLE_SCHEDULE_STEP: "/add-deductible-step-schedule",
  EDIT_DEDUCTIBLE_SCHEDULE_STEP: "/edit-deductible-step-schedule",
  DISPLAY_DEDUCTIBLE_SCHEDULE_STEP: "/display-deductible-step-schedule",
  ADD_DEDUCTIBLE_PATIENT_PAY_SCHEDULE: "/add-deductible-patient-pay-schedule",
  EDIT_DEDUCTIBLE_PATIENT_PAY_SCHEDULE: "/edit-deductible-patient-pay-schedule",
  DISPLAY_DEDUCTIBLE_PATIENT_PAY_SCHEDULE:
    "/display-deductible-patient-pay-schedule",
  DEDUCTIBLE_SCHEDULE_STEP_DETAIL_EXTENSION:
    "/deductible-step-schedule-detail-extension",
  OUT_OF_POCKET_PATIENT_PAY_SCHEDULE: "/out-of-pocket-patient-pay-schedule",
  BENEFIT_MAX_DRUG_STATUS_SCHEDULE: "/benefit-max-drug-status-schedule",
  ADD_OUT_OF_POCKET_PATIENT_PAY_SCHEDULE:
    "/add-out-of-pocket-patient-pay-schedule",
  EDIT_OUT_OF_POCKET_PATIENT_PAY_SCHEDULE:
    "/edit-out-of-pocket-patient-pay-schedule",
  DISPLAY_OUT_OF_POCKET_PATIENT_PAY_SCHEDULE:
    "/display-out-of-pocket-patient-pay-schedule",
  COPY_DEDUCTIBLE_SCHEDULE: "/deductible-schedule-copy",
  OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS: "/out-of-pocket-schedule-sub-steps",
  PATIENT_PAY_SCHEDULES: "/deductible-schedule-step-patient-pay-schedule",
  COPY_OUT_OF_POCKET_MAX_SCHEDULE: "/out-of-pocket-copy",
  OUT_OF_POCKET_MAX_SCHEDULE_NOTE: "/out-of-pocket-schedule-note",
  ADD_OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS:
    "/add-out-of-pocket-schedule-sub-steps",
  EDIT_OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS:
    "/edit-out-of-pocket-schedule-sub-steps",
  DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS:
    "/display-out-of-pocket-schedule-sub-steps",
  ADD_BENEFIT_MAX_DRUG_STATUS_SCHEDULE: "/add-benefit-max-drug-status-schedule",
  EDIT_BENEFIT_MAX_DRUG_STATUS_SCHEDULE:
    "/edit-benefit-max-drug-status-schedule",
  DISPLAY_BENEFIT_MAX_DRUG_STATUS_SCHEDULE:
    "/display-benefit-max-drug-status-schedule",
  COPY_BENEFIT_MAX_DRUG_STATUS_SCHEDULE:
    "/copy-benefit-max-drug-status-schedule",

  COPY_OUT_OF_POCKET_MAX_SCHEDULE: "/out-of-pocket-copy",

  BENEFIT_MAX_SCHEDULE_DISPLAY: "/display-benefit-max-schedule",
  BENEFIT_MAX_SCHEDULE_ADD: "/add-benefit-max-schedule",
  BENEFIT_MAX_SCHEDULE_EDIT: "/edit-benefit-max-schedule",
  COPY_BENEFIT_MAX_SCHEDULE: "/copy-benefit-max-schedule",

  BENEFIT_MAX_STEP_SCHEDULE_SEARCH: "/benefit-max-step-schedule",
  BENEFIT_MAX_STEP_SCHEDULE_DISPLAY: "/display-benefit-max-step-schedule",
  BENEFIT_MAX_STEP_SCHEDULE_ADD: "/add-benefit-max-step-schedule",
  BENEFIT_MAX_STEP_SCHEDULE_EDIT: "/edit-benefit-max-step-schedule",
  BENEFIT_MAX_SCHEDULE_NOTE: "/benefit-max-schedule-note",

  BENEFIT_ALT_COPAY_FORM_EDIT: "/benefit-alt-copay",

  BENEFIT_MAX_SCHEDULE: "/benefit-max-schedule",
  ALTERNATE_COPPAY_OVERRIDE: "/alternate-copay-override",
  ALTERNATE_COPAY_OVERRIDE_DISPLAY: "/display-alternate-copay-override",
  ALTERNATE_COPAY_OVERRIDE_ADD: "/add-alternate-copay-override",
  ALTERNATE_COPAY_OVERRIDE_EDIT: "/edit-alternate-copay-override",
  ACCUMULATION_CODE: "/accumulation-code",
  ACCUMULATION_CODE_EXTERNAL: "/accumulation-code-external",
  DRUG_STATUS_SCHEDULE: "/drug-status-schedule",
  ADD_DRUG_STATUS_SCHEDULE: "/add-drug-status_schedule",
  EDIT_DRUG_STATUS_SCHEDULE: "/edit-drug-status_schedule",
  DISPLAY_DRUG_STATUS_SCHEDULE: "/display-drug-status_schedule",

  ADD_ACCUMULATOR_OVERRIDE_SCHEDULE: "/add-accumulator-override-schedule",
  EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE: "/edit-accumulator-override-schedule",
  DISPLAY_ACCUMULATOR_OVERRIDE_SCHEDULE:
    "/display-accumulator-override-schedule",
  ADD_ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA:
    "/add-accumulator-override-schedule-criteria",
  EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE_CRITRIA:
    "/edit-accumulator-override-schedule-criteria",
  DISPLAY_ACCUMULATOR_OVERRIDE_SCHEDULE_CRITRIA:
    "/display-accumulator-override-schedule-criteria",
  ACCUMULATION_CODE_ADD: "/add-accumulation-code",
  ACCUMULATION_CODE_EDIT: "/edit-accumulation-code",
  ACCUMULATION_CODE_DISPLAY: "/display-accumulation-code",
  ADD_DRUG_STATUS_SCHEDULE: "/add-drug-status_schedule",
  EDIT_DRUG_STATUS_SCHEDULE: "/edit-drug-status_schedule",
  DISPLAY_DRUG_STATUS_SCHEDULE: "/display-drug-status_schedule",
  ACCUMULATION_CODE_LIST_ADD: "/add-accumulation-code-list",
  ACCUMULATION_CODE_LIST_EDIT: "/edit-accumulation-code-list",
  ACCUMULATION_CODE_LIST_DISPLAY: "/display-accumulation-code-list",
  ACCUMULATION_CODE_LIST: "/accumulation-code-list",
  ACCUMULATION_CODE_LIST_CODES: "/codes-in-accumulation-code-list",
  ADJUSTMENT_REASON_CODE_LIST: "/adjustment-reason-code-list",
  ADJUSTMENT_REASON_CODE_LIST_ADD: "/add-adjustment-reason-code-list",
  ADJUSTMENT_REASON_CODE_LIST_EDIT: "/edit-adjustment-reason-code-list",
  ADJUSTMENT_REASON_CODE_LIST_DISPLAY: "/display-adjustment-reason-code-list",
  CODES_IN_ADJUSTMENT_REASON_CODE_LIST: "/codes-in-adjustment-reason-code-list",
  ADJUSTMENT_REASON_CODE: "/adjustment-reason-code",
  ADJUSTMENT_REASON_CODE_ADD: "/add-adjustment-reason-code",
  ADJUSTMENT_REASON_CODE_EDIT: "/edit-adjustment-reason-code",
  ADJUSTMENT_REASON_CODE_DISPLAY: "/display-adjustment-reason-code",
  ACCUMULATOR_OVERRIDE_SCHEDULE: "/accumulator-overrride-schedule",
  ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA:
    "/accumulator-overrride-schedule-criteria",
  ACCUMULATOR_OVERRIDE_SCHEDULE_STATE: "/accumulator-overrride-schedule-state",
  ADD_ACCUMULATOR_OVERRIDE_SCHEDULE_STATE:
    "/add-accumulator-override-schedule-state",
  EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE_STATE:
    "/edit-accumulator-override-schedule-state",
  DISPLAY_ACCUMULATOR_OVERRIDE_SCHEDULE_STATE:
    "/display-accumulator-override-schedule-state",
  PLAN_OVERRIDE: "/plan-override",

  TROOP_SCHEDULE: "/troop-schedule",
  TROOP_SCHEDULE_ADD: "/add-troop-schedule",
  TROOP_SCHEDULE_EDIT: "/edit-troop-schedule",
  TROOP_SCHEDULE_DISPLAY: "/display-troop-schedule",
  MEDICARE_STANDARD_TROOP_SCHEDULE_STEPS: "/standard-troop-schedule-steps",
  MEDICARE_STANDARD_TROOP_SCHEDULE: "/standard-troop-schedule",
  MEDICARE_STANDARD_TROOP_SCHEDULE_STEPS_DETAIL:
    "/standard-troop-schedule-steps-detail",
  COPY_MERGE_ADJUSTMENT_REASON_CODE_LIST: "/copy-adjustment-reason-code-list",
  COPY_ACCUMULATION_CODE_LIST: "/copy-accumulation-code-list",
  DOSAGE_FORM_LIST: "dosage-form-list",
  DOSAGE_FORM: "dosage-form",
  PACKAGING_CODES_LIST: "packaging-codes-list",
  MEDICARE_LICS_SCHEDULE: "/lics-schedule",
  MEDICARE_LICS_SCHEDULE_DETAIL: "/lics-schedule-detail",
  TROOP_SCHEDULE_STEP: "/troop-schedule-step",
  TROOP_SCHEDULE_STEP_ADD: "/add-troop-schedule-step",
  TROOP_SCHEDULE_STEP_DISPLAY: "/display-troop-schedule-step",
  TROOP_SCHEDULE_STEP_EDIT: "/edit-troop-schedule-step",
  TROOP_SCHEDULE_STEP_MESSAGE: "/message-troop-schedule-step",
  TROOP_SCHEDULE_STEP_MESSAGE_ADD: "/add-message-troop-schedule-step",
  TROOP_SCHEDULE_STEP_MESSAGE_EDIT: "/edit-message-troop-schedule-step",
  TROOP_SCHEDULE_STEP_MESSAGE_DISPLAY: "/display-message-troop-schedule-step",
  COPY_TROOP_SCHEDULE: "/copy-troop-schedule",
  COPY_ACCUMULATOR_OVERRIDE_SCHEDULE: "/copy-accumulator-overrride-schedule",

  ACCUMULATOR_OVERRIDE_SCHEDULE_NOTE: "/accumulator-overrride-schedule-note",
  THIRD_PARTY_EXCEPTION: "/third-party-exception",
  ROUTE_OF_ADMINISTRATION: "/route-of-administration",
  ROUTE_OF_ADMINISTRATION_LIST: "/route-of-administration-list",
  DEA_CLASS_LIST: "/dea-class-list",
  CSR_FEDERAL_LEVEL: "/csr-federal-level",
  GPI_MSC_LIST: "/gpi-msc-list",
  NDC_LIST: "/ndc-list",
  CSR_STATE_LEVEL: "/csr-state-level",
  COST_SOURCE: "cost-source",
  COST_TYPE: "cost-type",
  MULTI_SOURCE_CODE_LIST: "/multi-source-code-list",
  STATE_LIST: "/state-list",
  MAC_LIST: "/mac-list",
  COPAY_SCHEDULE_STEP: "/copay-schedule-step",
  SELECT_MESSAGE: "/select-message",
};
export const VALIDATION_MESSAGES = {
  REQUIRED: "Value required.",
  MAXLENGTH: "Value cannot exceed {1} charecters.",
  MIN: "Value cannot be less than {1}.",
  MAX: "Value cannot be greater than {1}.",
  INVALID_DATE: "Invalid date.",
};

export const BUSINESS_OBJECT = {
  ACCUMS: "accumulator",
};

export const WRITE_ACCESS_CTA = [
  "EDIT",
  "DELETE",
  "ADD",
  "COPY",
  "HIDE",
  "UNHIDE",
  "INACTIVATE"
];

export const externalProgram = {
  RCAL1005: "ACCUMULATION_CODE_LIST",
  RCAD1005: "ADJUSTMENT_REASON_CODE_LIST",
  RCAD2003: "CODES_IN_ADJUSTMENT_REASON_CODE_LIST",
  RCAL2003: "ACCUMULATION_CODE_LIST_CODES",
  RCPLN018: "PLAN_OVERRIDE",
  RCOPC005: "OUT_OF_POCKET_MAX_SCHEDULE",
  RCDSC005: "DEDUCTIBLE_SCHEDULE",
  RCBSC005: "BENEFIT_MAX_SCHEDULE",
  RCTSC003: "TROOP_SCHEDULE",
};

export const EXTERNAL_PAGE_URI = {
  PATIENT_PAY_SCHEDULE: "/patient-pay-schedule",
  PATIENT_PAY_SCHEDULE_READ_ONLY: "/display-patient-pay-schedule",
  CLIENT_PATIENT_PAY_SCHEDULE: "/client-patient-pay-schedule",
  PATIENT_PAY_CLIENT_LIMITS: "/patient-pay-client-limits",
  PATIENT_PAY_SCHEDULE_CRITERIA: "/patient-pay-schedule-criteria",
};

export const LOCAL_SCREEN_VIEW = {
  RCOPC005: "DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE",
  RCTSC003: "TROOP_SCHEDULE_DISPLAY",
  RCDSC005: "DISPLAY_DEDUCTIBLE_SCHEDULE",
  RCBSC005: "BENEFIT_MAX_SCHEDULE_DISPLAY",
  RCACM001: "ACCUMULATION_CODE_DISPLAY"
};

export const LEGACY_SCREEN_VIEW = {
  RCPLN018: "RCPLN013I",
  RCFCH004: "RCFCH003I",
  RCMSG002: "RCMSG008",
  RCRAL004: "RCRAL003I",
  RCRAD900: "RCRAL003I",
  RCDFL005: "RCDFL003I",
  RCDCL005: "RCDCL003I",
  RCND1004: "RCND1003I",
  RCGP3004: "RCGP3003I",
  RCPKL005: "RCPKL003I",
  RCTSC003: "RCTSD001I",
  RCPS3001: "RCPS3004I",
  RCAL1005: "RCAL2003",
  RCSCS004: "RCSCS003I",
};
export const URL_SCREEN_NO = {};

export const SCHEDULES_DATA_KEY = {
  RCOPC005: "selectedSchedules",
  RCTSC003: "selectedSchedules",
  RCDSC005: "selectedSchedules",
  RCBSC005: "selectedPriceSchedules",
  RCACM001: "selectedCodes",
};

export const EXTERNAL_SCHEDULES_DATA_KEY = {
  PATIENT_PAY_SCHEDULE_READ_ONLY: "selectedPatients",
  CLIENT_PATIENT_PAY_SCHEDULE: "selectedPatients",
  PATIENT_PAY_CLIENT_LIMITS: "selectedPatients",
  PATIENT_PAY_SCHEDULE_CRITERIA: "selectedPatients",
};

export const FN_SHIFT_KEY_MAPPING = {
  F1: "F13",
  F2: "F14",
  F3: "F15",
  F4: "F16",
  F5: "F17",
  F6: "F18",
  F7: "F19",
  F8: "F20",
  F9: "F21",
  F10: "F22",
  F11: "F23",
  F12: "F24",
}

export const VALID_FUNCTION_KEYS = [
  "F1",
  "F2",
  "F3",
  "F4",
  "F5",
  "F6",
  "F7",
  "F8",
  "F9",
  "F10",
  "F11",
  "F12",
  "F13",
  "F14",
  "F15",
  "F16",
  "F17",
  "F18",
  "F19",
  "F20",
  "F21",
  "F22",
  "F23",
  "F24",
]

export const TRUSTED_DOMAIN = {
  TRUSTED_DOMAINS: /(^localhost$|(^|\.)optum\.com$)/,
};

;
export const NO_CHANGE_OF_INFO = "No Change of Information";
